module.exports = __webpack_public_path__ + "media/images/ticket/to_purchase-ba33cefabe6037279c2eb9cd9b672d2d.png";